// Emptiness check for audit/survey general-info field values.
// lodash `isEmpty` treats 0 and false as empty, wrongly discarding valid
// numeric/boolean answers. Only null/undefined, '', empty array and empty
// plain object (the legacy {} sentinel) count as empty here.
export const isEmptyFieldValue = (value: any): boolean => {
  if (value == null || value === '') return true;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === 'object') return Object.keys(value).length === 0;
  return false;
};
